import { createReducer } from '@reduxjs/toolkit'

import { userLogout } from '@/redux/auth/actions'
import {
  editUserDataFailed,
  editUserDataRequest,
  editUserDataSuccess,
  editUserSettingsFailed,
  editUserSettingsRequest,
  editUserSettingsSuccess,
  getUserDataFailed,
  getUserDataRequest,
  getUserDataSuccess
} from './actions'
import { IUserData } from './types'

interface IGetUserDataState {
  loading: boolean
  userData: IUserData | undefined
}

const initialState: IGetUserDataState = {
  loading: false,
  userData: undefined
}

const userReducer = createReducer(initialState, builder => {
  builder
    .addCase(getUserDataRequest, state => {
      state.loading = true
    })
    .addCase(getUserDataSuccess, (state, action) => {
      state.loading = false
      state.userData = action.payload.userData
    })
    .addCase(getUserDataFailed, state => {
      state.loading = false
      state.userData = undefined
    })
    .addCase(editUserDataRequest, state => {
      state.loading = true
    })
    .addCase(editUserDataSuccess, (state, action) => {
      state.loading = false
      state.userData = { ...state.userData, ...action.payload.userData }
    })
    .addCase(editUserDataFailed, state => {
      state.loading = false
      state.userData = undefined
    })
    .addCase(editUserSettingsRequest, state => {
      state.loading = true
    })
    .addCase(editUserSettingsSuccess, (state, action) => {
      state.loading = false
      state.userData = {
        ...state.userData as IUserData,
        settings: { ...{ ...state.userData?.settings || {} }, ...action.payload }
      }
    })
    .addCase(editUserSettingsFailed, state => {
      state.loading = false
    })
    .addCase(userLogout, state => {
      state.loading = false
      state.userData = undefined
    })
})

export default userReducer
